goog.provide("shadow.js.shim.module$$mui$material$ClickAwayListener");
goog.provide("module$shadow_js_shim_module$$mui$material$ClickAwayListener");
shadow.js.shim.module$$mui$material$ClickAwayListener = shadow.js.nativeProvides["@mui/material/ClickAwayListener"] = shadow$bridge("@mui/material/ClickAwayListener");
module$shadow_js_shim_module$$mui$material$ClickAwayListener.default = shadow.js.shim.module$$mui$material$ClickAwayListener;
